<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('defaultCommission.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('defaultCommission.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info"
						@click.prevent="add"
					>
            {{
            $t('add_new')
            }}
          </ts-button>
          <!-- <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div> -->
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
				:rowGroup="{
					field: 'dealer_type.dealer_type'
				}"
      >
        <template v-slot="{ record }">
          <td>{{ record.topup_commission_rate }}</td>
          <td>{{ record.payout_comission_rate }}</td>
          <td>{{ record.credit_allow }}</td>
          <td>{{ record.payout_limit }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>			
    </ts-card>
		<!-- form create or update -->
		<a-modal
			v-if="show_form"
			v-model="show_form"
			:title="$t('create')"
			:footer="null"
			width="400px"
			@cancel="onCancel"
		>
			<FormComponent @cancel="onCancel" :editData="edit_data"/>
		</a-modal>
  </div>
</template>

<script>
import FormComponent from './components/form'
import { mapState } from 'vuex'
export default {
	name: 'defaultCommision',
	components: {
		FormComponent
	},
  data() {
    return {
			loading: false,
			show_form: false,
			edit_data: null
    }
	},
	created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/defaultCommission', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.defaultCommission.search
      },
      set(newValue) {
        this.$store.commit('accounting/defaultCommission/SET_SEARCH', newValue)
        this.$store.commit('accounting/defaultCommission/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('defaultCommission.topUpRate') },
        { name: this.$t('defaultCommission.payoutRate') },
        { name: this.$t('defaultCommission.creditAllow') },
        { name: this.$t('defaultCommission.payoutLimit') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
	methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/defaultCommission/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
		add(){
			this.show_form = true
		},
		onCancel(){
			this.show_form = false
			this.edit_data = null
			this.fetchData()
		},
		edit(record){
			this.edit_data = record
			this.show_form = true
		}
	}
}
</script>